import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import { faCalendar, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import * as countdown from 'countdown';
import { FirebaseAuthComponent } from '../shared/firebase-auth/firebase-auth.component';
import { AreaInteresService } from '../shared/services/area-interes/area-interes.service';
import { CentersService } from '../shared/services/centers/centers.service';
import { CodeService } from '../shared/services/codes/code.service';
import { CursosHorariosService } from '../shared/services/cursos-horarios/cursos-horarios.service';
import { CursosService } from '../shared/services/cursos/cursos.service';
import { SendEmailService } from '../shared/services/email/send-email.service';
import { EstudianteService } from '../shared/services/estudiante/estudiante.service';
import { GrupoService } from '../shared/services/grupo/grupo.service';
import { InscripcionService } from '../shared/services/inscripcion/inscripcion.service';
import { MessagesService } from '../shared/services/messages/message.service';
import { MunicipalityCenterService } from '../shared/services/municipality-center/municipality-center.service';
import { SeriesService } from '../shared/services/series/series.service';
import { TutorService } from '../shared/services/tutor/tutor.service';
import * as moment from 'moment';

@Component({
  selector: 'app-info-academica',
  templateUrl: './info-academica.component.html'
})
export class InfoAcademicaComponent implements OnInit {

  @Input()
  idTutor: string;

  @Input()
  isCampus: boolean;

  @Output()
  atras = new EventEmitter();
  alumnos: Array<any> = [];
  cursosFiltradosAlumno: Array<any> = [];
  cursosFiltradosAlumnoAMostrar: Array<any> = [];
  cursosFiltradosAlumnoHora: Array<any> = [];
  areaInteres: Array<any> = [];
  areaInteresCursosActivos: Array<any> = [];
  centers: Array<any> = [];
  municipalityCenters: Array<any> = [];
  tutor: any;
  cursos: Array<any> = [];
  grupos: Array<any> = [];
  cursosFiltrados: Array<any> = [];
  areaIdFiltro: any;
  municipioIdFiltro: any;
  centroIdFiltro: any;
  diaFiltro: any;
  horasInicio: Array<any> = [];
  horasFin: Array<any> = [];
  horasCursos: Array<any> = [];
  banderaBotonAtras = true;
  banderaBotonSiguiente = false;
  habiliarDiaSemana: Array<boolean> = [];
  habiliarHora: Array<boolean> = [];
  habiliarCentro: Array<boolean> = [];
  habiliarBotonSiguiente = true;
  habiliarMunicipio: Array<boolean> = [];
  cursosHorarios: Array<any> = [];
  centrosPorMunicipio: Array<any> = [];
  banderaBusquedaOtrasOpciones: Array<boolean> = [];
  series: Array<any> = [];
  initCourseDate: Date;
  endCourseDate: Date;
  banderaBotonConfirmar: Array<any> = [];
  checkOtrasOpciones = true;
  banderaBotonConfirmarOtrasOpciones: Array<any> = [];
  cursosElegido: Array<any> = [];
  banderaCursoSinCupos: Array<any> = [];
  banderaHabilitarRadioButton: Array<any> = [];
  banderaHabilitarRadioButtonOtrasOpciones: Array<any> = [];
  banderaBotonSiguienteGuardar = true;
  banderaListaDeEspera: Array<any> = [];

  barraProgreso = false;
  progreso: number;

  cargando = false;
  banderaEliminarDatosDesdeContrato = false;
  codigosIguales = false;
  banderaMensajeWeb = false;
  flagArea = false;

  daysOfWeek: { label: string, value: string }[] = [{
    label: 'Lunes',
    value: 'Lunes'
  }, {
    label: 'Martes',
    value: 'Martes'
  }, {
    label: 'Miércoles',
    value: 'Miercoles'
  }, {
    label: 'Jueves',
    value: 'Jueves'
  }, {
    label: 'Viernes',
    value: 'Viernes'
  }, {
    label: 'Sábado',
    value: 'Sabado'
  }, {
    label: 'Domingo',
    value: 'Domingo'
  }];

  centrosMunicipioAlumnos: { id: number, centros: any[] }[] = [];

  powerOffIcon = faPowerOff;

  calendarIcon = faCalendar;

  constructor(private areaService: AreaInteresService, private centersService: CentersService,
              private municipalityService: MunicipalityCenterService, private tutorService: TutorService,
              private estudianteService: EstudianteService, private cursosService: CursosService,
              private grupoService: GrupoService, private cursosHorariosService: CursosHorariosService,
              private inscripcionService: InscripcionService, private seriesService: SeriesService,
              private emailService: SendEmailService,
              private codeService: CodeService,
              private messageService: MessagesService,
              private router: Router,
              private firebaseAuth: FirebaseAuthComponent) {
  }

  async ngOnInit(): Promise<void> {
    this.progreso = 25;
    if (this.idTutor != null) {
      localStorage.setItem('idTutor', this.idTutor);
      this.obtenerTutor(this.idTutor);
    } else {
      if (localStorage.getItem('idTutor') != null) {
        this.idTutor = localStorage.getItem('idTutor');
        this.obtenerTutor(this.idTutor);

      } else {
        // tslint:disable-next-line: deprecation
        this.tutorService.currentIdTutor$.subscribe(res => {
          const idTemp = res;
          this.idTutor = idTemp.valueOf();
          localStorage.setItem('idTutor', this.idTutor);
          this.obtenerTutor(this.idTutor);
        });
      }
    }
    
     // tslint:disable-next-line: deprecation
    this.cursosService.getCursosActivos().subscribe(res => {
      this.cursos = res;
      // tslint:disable-next-line: deprecation
      this.areaService.getAreaInteresCollection().subscribe(areas => {
        this.areaInteres = areas;
        this.filtrarAreasConCursosActivos();
      });
    });
    // tslint:disable-next-line: deprecation
    this.centersService.getCentersCollection().subscribe(res => {
      this.centers = res;
    });
    // tslint:disable-next-line: deprecation
    this.municipalityService.getMunicipalityCentersCollection().subscribe(res => {
      this.municipalityCenters = res;
    });
    // tslint:disable-next-line: deprecation
    this.grupoService.getGroupsCollection().subscribe(res => {
      this.grupos = res;
    });
    // tslint:disable-next-line: deprecation
    this.cursosHorariosService.getCursosHorariosCollection().subscribe(res => {
      this.cursosHorarios = res;
    });
    // tslint:disable-next-line: deprecation
    this.seriesService.getSeriesCollection().subscribe(res => {
      this.series = res;
    });

    // const headersToSend = { title: 'INSCRIPCIÓN Información Académica', img1: '../../assets/img/menu/barra2.png' };
    // this.tutorService.getHeaderObservable().next(headersToSend);
    // this.barraProgreso = true;
    this.banderaBotonAtras = true;
  } 
  // Funcion que recoge la fecha de inicio del curso seleccionado
  async getCurseInformation(): Promise<void> {
    await this.estudianteService.getUser(this.idTutor).subscribe(tutor => {
      tutor.alumns.forEach(async alumno => {
        await alumno.get().then( snapchot => {
          this.cursosService.getCurso(snapchot.data().idLastCourse).subscribe(curso => {
            this.initCourseDate = new Date(curso.data()?.startDate?.seconds * 1000)
            this.endCourseDate = new Date(curso.data()?.endDate?.seconds * 1000)
          })
        });
      });
    });
  }
  
  // Filtro que ispone todos aquellos centros en los que apararezcan en cursos activos o futuros en el monicipio seleccionado
  getCentrosDelAlumno(idAlumno, courses): any {
    // se obtiene primero el listado de cursos activos o futuros
    const filterCurses = []
    courses.forEach((course) => {
      if (moment(course['endDate']?.seconds * 1000) >= moment()) {
        // se selecionan aquellos identificadores que no esten en la list 
        if (!filterCurses.includes(course['center'].id)) {
          filterCurses.push(course['center'].id)
        }
      }
    })
    // se aplica el filtro al listado de centros para cada alumno.
    return this.centrosMunicipioAlumnos?.find(it => it.id === idAlumno)?.centros.filter(centro => filterCurses.includes(centro.id));
  }

  // Filtro que dispone todos aquellos municipios que tengan una curso futuro o actual
  filterMunicipalityByCourseEndDate(courses: any, municipalitys: any): Array<object> {
    const coursesActualOrFuture = []
    courses.forEach((course) => {
      if (moment(course['endDate']?.seconds * 1000) >= moment()) {
        if (!coursesActualOrFuture.includes(course['municipality'].id)) {
          coursesActualOrFuture.push(course['municipality'].id)
        }
      }
    })
    return municipalitys.filter(municipality => coursesActualOrFuture.includes(municipality.id))
  }


  // Obtiene los centros de cada municipio
  filtrarCentro(alumnoItem, idMunicipio): void {
    this.habiliarBotonSiguiente = true;
    alumnoItem.centro = null;
    const alumnCentros = this.centrosMunicipioAlumnos.find(it => it.id === alumnoItem.id);
    alumnCentros.centros = this.centers.filter(it => it.town.id === idMunicipio);
  }
  // Obtiene los areas con cursos activos
  filtrarAreasConCursosActivos(): void {
    let banderaAreaInsertada = true;
    this.areaInteresCursosActivos = [];
    this.areaInteres.forEach(area => {
      banderaAreaInsertada = true;
      this.cursos.filter(curso => {
        // console.log('el area es', area);
        const areaName: string = area.name;
        if (this.tutor.isCampus) {
          if (areaName.includes('Campus')) {
            return true;
          }
          return false;
        } else {
          if (!areaName.includes('Campus')) {
            return true;
          }
          return false;
        }
      })
      .forEach(curso => {
        if ((curso.area.id === area.id) && banderaAreaInsertada) {
          this.areaInteresCursosActivos.push(area);
          banderaAreaInsertada = false;
        }
      }
      );
    });
  }

  areaSelected(area: any, index: number, itemAlum: any): boolean {
    const areaName: string = area.name;
    if (this.tutor.isCampus) {
      if (areaName.includes('Campus')) {
        return true;
      }
      return false;
    } else {
      if (areaName.includes('Robótica y Programación') && !this.flagArea) {
        itemAlum.areaId = area.id;
        this.onSelectArea(area.id, index);
        this.flagArea = true;
        return true;
      }
      return false;
    }

    return false;
  }

  // estable las horas ofrecidas en un dia de la semana
  filtrarHorasCursos(alumnoItem, dia, indexAlumno): void {
    alumnoItem.horaCursoSeleccionada = null;
    this.habiliarBotonSiguiente = true;
    alumnoItem.horasCursos = (alumnoItem.horasCursos) ? alumnoItem.horasCursos : [];
    this.cursosHorarios.forEach(element => {
      if (element.weekDays.includes(dia)) {
        if (element.startTime.minute == '0') {
          element.startTime.minute = '00';
        }
        if (element.endTime.minute == '0') {
          element.endTime.minute = '00';
        }
        alumnoItem.horasCursos.push(element.startTime.hour + ':' + element.startTime.minute
          + ' - ' + element.endTime.hour + ':' + element.endTime.minute);
        alumnoItem.horasCursos = [...new Set(alumnoItem.horasCursos)];
        // this.horasCursoSelect = alumnoItem.horasCursos;
        if (this.alumnos[indexAlumno].horasCursos && this.alumnos[indexAlumno].horasCursos.length === 0) {
          this.alumnos[indexAlumno].horasCursos = alumnoItem.horasCursos;
        }

      }
    });
    console.log('las horas curso son ', alumnoItem.horasCursos, this.alumnos[indexAlumno]);
    // this.selectedCurse = this.alumnos[indexAlumno]?.cursoElegido
    this.habiliarHora[indexAlumno] = false;
  }

  // filtrado general
  filtrarCursos(indexAlumno, alumnoItem): void {
    alumnoItem.horaCursoSeleccionada = null;
    this.cursosFiltradosAlumnoAMostrar[indexAlumno] = [];
    if (this.validarFiltrosNotNull(alumnoItem)) {
      this.cursosFiltrados = [];
      alumnoItem.horasCursos = [];
      this.cursos.forEach(element => {
        if (this.validacionCondicionesFiltrado(element, alumnoItem)) {
          this.cursosFiltrados.push(element);
        }
      }
      );
      this.cursosFiltradosAlumnoAMostrar[indexAlumno] = this.cursosFiltradosAlumnoHora;
      this.cursosFiltradosAlumno[indexAlumno] = this.cursosFiltrados;
    }
  }

  // Metodo que se llama cuando se quieren otras opciones de cursos
  filtrarCursosOtraOpciones(indexAlumno, alumnoItem): void {
    this.cursosFiltradosAlumnoAMostrar[indexAlumno] = [];
    if (this.validarFiltrosNotNull(alumnoItem)) {
      this.cursosFiltrados = [];
      alumnoItem.horasCursos = [];
      this.cursos.forEach(element => {
        if (this.validacionCondicionesFiltrado(element, alumnoItem)) {
          if (element.startTime.minute === '0') {
            element.startTime.minute = '00';
          }
          if (element.endTime.minute === '0') {
            element.endTime.minute = '00';
          }
          this.cursosFiltrados.push(element);
          alumnoItem.horasCursos.push(element.startTime.hour + ':' + element.startTime.minute
            + ' - ' + element.endTime.hour + ':' + element.endTime.minute);
          alumnoItem.horasCursos = [...new Set(alumnoItem.horasCursos)];
        }
      }
      );
      this.cursosFiltradosAlumno[indexAlumno] = this.cursosFiltrados;
      this.cursosFiltradosAlumnoAMostrar[indexAlumno] = this.cursosFiltrados;
    }
    // Mostrar opciones para el curso elegido
    if (this.cursosFiltradosAlumnoAMostrar[indexAlumno].length === 0) {
      this.cursosFiltradosAlumnoAMostrar[indexAlumno] =
        this.filtrarCursosOtraOpcionesSinCondiciones(indexAlumno, alumnoItem, true, false, false);
      if (this.cursosFiltradosAlumnoAMostrar[indexAlumno].length === 0) {
        this.cursosFiltradosAlumnoAMostrar[indexAlumno] =
          this.filtrarCursosOtraOpcionesSinCondiciones(indexAlumno, alumnoItem, false, true, false);
        if (this.cursosFiltradosAlumnoAMostrar[indexAlumno].length === 0) {
          this.cursosFiltradosAlumnoAMostrar[indexAlumno] =
            this.filtrarCursosOtraOpcionesSinCondiciones(indexAlumno, alumnoItem, false, false, true);
        }
      }
    }
    this.banderaBusquedaOtrasOpciones[indexAlumno] = true;
    this.banderaBotonConfirmarOtrasOpciones[indexAlumno] = true;
    this.banderaHabilitarRadioButtonOtrasOpciones[indexAlumno] = false;
    if (this.cursosFiltradosAlumnoAMostrar[indexAlumno].length === 0) {
      this.banderaHabilitarRadioButtonOtrasOpciones[indexAlumno] = null;
      this.alumnos[indexAlumno].cursoElegido = null;
      this.banderaBotonConfirmarOtrasOpciones[indexAlumno] = false;

    }
    // Establecer la descripcion del municipio y centro en cursos filtrados
    this.cursosFiltradosAlumnoAMostrar[indexAlumno].forEach(element => {
      this.obtenerDescripcionCentro(element);
      this.obtenerDescripcionMunicipio(element);
    });
  }

  filtrarCursosOtraOpcionesSinCondiciones(indexAlumno, alumnoItem, opcion2, opcion3, opcion4): any[] {
    this.cursosFiltradosAlumnoAMostrar[indexAlumno] = [];
    let aux = false;
    this.cursosFiltrados = [];
    alumnoItem.horasCursos = [];
    this.cursos.forEach(element => {
      if (opcion2) {
        aux = this.validacionCondicionesFiltradoSinDia(element, alumnoItem);
      } else {
        if (opcion3) {
          aux = this.validacionCondicionesFiltradoSinCentro(element, alumnoItem);
        } else {
          if (opcion4) {
            aux = this.validacionCondicionesFiltradoSinCentroDiaHora(element, alumnoItem);
          }
        }
      }
      if (aux) {
        if (element.startTime.minute == '0') {
          element.startTime.minute = '00';
        }
        if (element.endTime.minute == '0') {
          element.endTime.minute = '00';
        }
        this.cursosFiltrados.push(element);
        alumnoItem.horasCursos.push(element.startTime.hour + ':' + element.startTime.minute
          + ' - ' + element.endTime.hour + ':' + element.endTime.minute);
        alumnoItem.horasCursos = [...new Set(alumnoItem.horasCursos)];
      }
    });
    return this.cursosFiltrados;
  }

  // Se hace el filtro por la hora seleccionada por el usuario
  filtrarCursosPorHora(indexAlumno, alumnoItem): void {
    this.cursosFiltradosAlumnoAMostrar[indexAlumno] = [];
    this.cursosFiltradosAlumnoHora = [];
    this.cursosFiltradosAlumno[indexAlumno].forEach(element => {
      if (element.startTime.minute == '0') {
        element.startTime.minute = '00';
      }
      if (element.endTime.minute == '0') {
        element.endTime.minute = '00';
      }
      if (alumnoItem.horaCursoSeleccionada != null && alumnoItem.horaCursoSeleccionada ===
        (element.startTime.hour + ':' + element.startTime.minute
          + ' - ' + element.endTime.hour + ':' + element.endTime.minute)) {
        this.cursosFiltradosAlumnoHora.push(element);
      }
    });
    this.cursosFiltradosAlumnoAMostrar[indexAlumno] = this.cursosFiltradosAlumnoHora;
    this.cursosFiltradosAlumno[indexAlumno] = this.cursosFiltrados;

    this.cursosFiltradosAlumnoAMostrar[indexAlumno].forEach(element => {
      this.obtenerDescripcionCentro(element);
      this.obtenerDescripcionMunicipio(element);
    });

    // habilitacion boton siguiente
    let auxBanderaHabilitarBotonSiguiente: boolean;
    auxBanderaHabilitarBotonSiguiente = false;
    this.alumnos.forEach(element => {
      if (element.horaCursoSeleccionada != null && !auxBanderaHabilitarBotonSiguiente) {
        auxBanderaHabilitarBotonSiguiente = false;
      } else {
        auxBanderaHabilitarBotonSiguiente = true;
      }
    });
    this.habiliarBotonSiguiente = auxBanderaHabilitarBotonSiguiente;
  }

  onSelectArea($event, index): void {
    console.log('on select area ', this.alumnos[index]);
    const areaSelected = this.areaInteresCursosActivos.find(it => it.id === $event);
    if (areaSelected) {
      this.alumnos[index].areaInteres = areaSelected.name;
      this.filtrarCursos(index, this.alumnos[index]);
      this.habiliarMunicipio[index] = false;
      // this.habiliarDiaSemana[index] = null;
    } else {
      this.alumnos[index].areaId = null;
      this.alumnos[index].areaInteres = null;
      this.alumnos[index].municipio = null;
      this.alumnos[index].municipioId = null;
      this.alumnos[index].centro = null;
      this.alumnos[index].centroId = null;
      this.alumnos[index].dia = null;
      this.alumnos[index].horaCursoSeleccionada = null;
      this.habiliarMunicipio[index] = null;
      this.habiliarCentro[index] = null;
      this.habiliarDiaSemana[index] = null;
    }
  }

  onSelectMunicipality($event, index): void {
    console.log('se ejecutó en onSelectMunicipality', this.cursosFiltradosAlumno);
    const municipalitySelected = this.municipalityCenters.find(it => it.id === $event);
    if (municipalitySelected) {
      this.alumnos[index].municipio = municipalitySelected.municipality;
      this.filtrarCentro(this.alumnos[index], $event);
      this.habiliarCentro[index] = false;
    } else {
      this.alumnos[index].municipio = null;
      this.alumnos[index].municipioId = null;
      this.alumnos[index].centro = null;
      this.alumnos[index].centroId = null;
      this.alumnos[index].dia = null;
      this.alumnos[index].horaCursoSeleccionada = null;
      this.habiliarCentro[index] = null;
      this.habiliarDiaSemana[index] = null;
    }
  }

  onSelectCenter($event, index): void {
    // const centerSelected = this.centrosPorMunicipio.find(it => it.id === $event);
    console.log('se ejecutó en onSelectCenter', this.cursosFiltradosAlumno);
    const centerSelected = this.centrosMunicipioAlumnos
    .filter(element => element.centros.length > 0)[index].centros.find(it => it.id === $event);
    if (centerSelected) {
      this.alumnos[index].centro = centerSelected.description;
      this.habiliarDiaSemana[index] = false;
    } else {
      this.alumnos[index].centro = null;
      this.alumnos[index].centroId = null;
      this.alumnos[index].dia = null;
      this.alumnos[index].horaCursoSeleccionada = null;
      this.habiliarDiaSemana[index] = null;
    }
  }

  onSelectDay($event, index): void {
    console.log('se ejecutó en onSelectDay', this.cursosFiltradosAlumno);
    this.diaFiltro = $event;
    this.filtrarCursos(index, this.alumnos[index]);
    this.filtrarHorasCursos(this.alumnos[index], $event, index);
    console.log('se ejecutó en onSelectDay después', this.cursosFiltradosAlumno);
  }

  onSelectHourly($event, index): void {
    this.filtrarCursosPorHora(index, this.alumnos[index]);
  }

  logout(): void {
    this.firebaseAuth.eliminarInscripcionesAlumnos(this.alumnos);
    this.firebaseAuth.logout();
    localStorage.removeItem('idTutor');
  }

  private validacionCondicionesFiltrado(element: any, alumnoItem): boolean {
    return element.area.id === alumnoItem.areaId
      && element.center.id === alumnoItem.centroId
      && element.municipality.id === alumnoItem.municipioId
      && this.validarCupos(element)
      && element.weekDays.includes(alumnoItem.dia)
      && this.validarRangoEdad(element, alumnoItem);
  }

  private validacionCondicionesFiltradoSinDia(element: any, alumnoItem): boolean {
    return element.area.id === alumnoItem.areaId
      && element.center.id === alumnoItem.centroId
      && element.municipality.id === alumnoItem.municipioId
      && this.validarCupos(element)
      && this.validarRangoEdad(element, alumnoItem);
  }

  // metodo utilizado cuando se busca en cualquier centro el curso
  private validacionCondicionesFiltradoSinCentro(element: any, alumnoItem): boolean {
    return element.area.id === alumnoItem.areaId
      && this.validarCupos(element)
      && element.weekDays.includes(alumnoItem.dia)
      && this.validarRangoEdad(element, alumnoItem)
      && (alumnoItem.horaCursoSeleccionada != null && alumnoItem.horaCursoSeleccionada ===
        (element.startTime.hour + ':' + element.startTime.minute
          + ' - ' + element.endTime.hour + ':' + element.endTime.minute));
  }
  private validacionCondicionesFiltradoSinCentroDiaHora(element: any, alumnoItem): boolean {
    return element.area.id === alumnoItem.areaId
      && this.validarCupos(element)
      && this.validarRangoEdad(element, alumnoItem);
  }

  private validarRangoEdad(curso, alumnoItem): boolean {
    let bandera = false;
    this.grupos.forEach(element => {
      if (element.id === curso.group.id) {
        if (alumnoItem.age != null && (element.edadInicial <= alumnoItem.age)) {
          if (alumnoItem.age <= element.edadFinal) {
            bandera = true;
          }
        }
      }
    });
    return bandera;
  }

  private validarCupos(curso): boolean {
    return curso.high < curso.maximun;
  }

  private validarFiltrosNotNull(alumnoItem): any {
    return alumnoItem.areaId != null
      && alumnoItem.centroId != null
      && alumnoItem.municipioId != null
      && alumnoItem.dia != null;
  }

  // Cargar tutor y estudiante creados
  obtenerTutor(id): void {
    this.tutorService.getUser(id).subscribe(res => {
      this.tutor = res;
      if (this.tutor != null) {
        this.progreso = 35;
        this.establecerDatosAlumnos(this.tutor.alumns);
      }
    });
  }

  establecerDatosAlumnos(alumnosTutor): void {
    if (alumnosTutor != null) {
      this.progreso = 65;
      this.centrosMunicipioAlumnos = [];
      alumnosTutor.forEach(element => {
        this.centrosMunicipioAlumnos.push({ id: element.id, centros: [] });
        this.progreso = 85;
        this.estudianteService.getUser(element.id).subscribe(res => {
          this.agregarAlumno(res);
        });
        this.barraProgreso = true;
      });
    } else {
      this.barraProgreso = true;
    }

  }
  agregarAlumno(alumno): void {
    const banderaInsertar = this.validarInsercion(alumno);
    if (banderaInsertar) {
      const validarAddAlumno = (alumno.emailSend == null || alumno.emailSend != 'enviado') && (alumno.status != 'matriculado' || alumno?.isNewInscription);
      if (validarAddAlumno) {
        this.insertarYLimpiarDatosAlumno(alumno);
      }
    }
  }

  private insertarYLimpiarDatosAlumno(alumno: any) {
    //this.centrosMunicipioAlumnos.push({ id: alumno.id, centros: [] });
    this.alumnos.push(alumno);
    if (alumno?.isNewInscription && (alumno?.lastInscriptionId == null || alumno?.lastInscriptionId === '')) {
      this.crearInscripcionNuevoCurso(alumno);
    } else {
      this.eliminarYLimpiarDesdePaginaContrato(alumno);
    }
  }

  private async crearInscripcionNuevoCurso(alumno): Promise<void> {
    const idInscription = (Date.now().toString(36) + Math.random().toString(36).substr(2, 24));
    //status temporal
    alumno.status = 'prospectivo';
    alumno.lastInscripcionId = idInscription;
    await this.inscripcionService.insertarIncripcion(alumno, this.tutor, alumno.id, this.tutor.id);
    await this.tutorService.updateUserLastInscriptionId(alumno.id, alumno.lastInscripcionId);

  }

  private validarInsercion(alumno: any) {
    let banderaInsertar = true;
    this.alumnos.forEach(element => {
      if (element.id == alumno.id) {
        banderaInsertar = false;
      }
    });
    return banderaInsertar;
  }

  eliminarYLimpiarDesdePaginaContrato(alumno): void {
    alumno.areaInterest = null;
    alumno.municipio = null;
    alumno.centro = null;
    alumno.dia = null;
    alumno.horaCursoSeleccionada = null;
    if (alumno.status == 'espera') {
      this.eliminarDeListaEspera(alumno);
      alumno.cursoElegido = null;
    } else {
      this.consultarCuposGrupoAEliminar(alumno);
    }
    this.limpiarDatosGenerales();
  }

  // Boton atras limpia todos los filtros
  limpiarFiltros(): void {
    try {
      this.alumnos.forEach(element => {
        element.areaId = null;
        element.areaInteres = null;
        element.municipio = null;
        element.municipioId = null;
        element.centro = null;
        element.centroId = null;
        element.dia = null;
        element.areaInterest = null;
        element.municipio = null;
        element.centro = null;
        element.dia = null;
        element.horaCursoSeleccionada = null;
        element.time = null;
        clearInterval(element.timeId);
        if (element.cursoElegido != null && element.inscripcionId != null && element.cursoElegido !== 'lista' && element.cursoElegido !== 'otras') {
          this.eliminarReserva(element);
        } else {
          if (element.listaEspera != null && element.listaEspera) {
            this.eliminarDeListaEspera(element);
          }
          element.cursoElegido = null;
        }
      });
    } catch (error) {
      console.log('verificar reseteo datos info academica');
    }
    this.limpiarDatosGenerales();

  }

  limpiarDatosGenerales(): void {
    this.habiliarDiaSemana = [];
    this.habiliarHora = [];
    this.habiliarMunicipio = [];
    this.banderaBusquedaOtrasOpciones = [];
    this.banderaBotonConfirmarOtrasOpciones = [];
    this.banderaHabilitarRadioButtonOtrasOpciones = [];
    this.banderaHabilitarRadioButton = [];
    this.banderaBotonConfirmar = [];
    this.habiliarCentro = [];
    this.habiliarBotonSiguiente = true;
    this.banderaListaDeEspera = [];
  }

  obtenerDescripcionMunicipio(curso): void {
    this.municipalityCenters.forEach(element => {
      if (element.id == curso.municipality.id) {
        curso.descripcionMunicipio = element.municipality;
        return;
      }
    }
    );
  }
  obtenerDescripcionCentro(curso): void {
    this.centers.forEach(element => {
      if (element.id == curso.center.id) {
        curso.descripcionCentro = element.description;
        return;
      }
    });
  }

  escogerOtrasOpcionesOListaEspera(indexAlumno, alumnoItem): void {
    if (this.checkOtrasOpciones) {
      this.filtrarCursosOtraOpciones(indexAlumno, alumnoItem)
    } else {
      if (!(alumnoItem.cursoElegido != null && alumnoItem.cursoElegido == 'ninguno')) {
        this.listaEsperaInscribir(alumnoItem);
        this.banderaListaDeEspera[indexAlumno] = true;
      }
      this.banderaBotonConfirmarOtrasOpciones[indexAlumno] = true;
      this.banderaHabilitarRadioButtonOtrasOpciones[indexAlumno] = false;
      this.habilitarGuardado();
    }
  }

  elegirCurso(alumnoItem, curso): void {
    alumnoItem.cursoElegido = { ...curso };
    alumnoItem.horaSeleccionada = curso.startTime.hour + ':' + curso.startTime.minute + '-'
      + curso.endTime.hour + ':' + curso.endTime.minute;
    alumnoItem.dia = curso.weekDays[0];
  }

  // Descarma cursos elegido y restablece valores
  desmarcarCurso(alumnoItem, indexAlumno): void {
    const temporalCursosFiltradosAlumnos = this.cursosFiltradosAlumnoAMostrar[indexAlumno];
    this.cursosFiltradosAlumnoAMostrar[indexAlumno] = [];
    // se debe esperar un milisegundo para que recargue la lista en el DOM
    setTimeout(() => {
      this.cursosFiltradosAlumnoAMostrar[indexAlumno] = temporalCursosFiltradosAlumnos;
      // aumentar de nuevo la plaza en los diferentes alumnos
      let auxDescuento = true;
      this.cursosFiltradosAlumnoAMostrar.forEach(element => {
        element.forEach(element => {
          if ((element.id == alumnoItem.cursoElegido.id) && auxDescuento) {
            element.high = element.high - 1;
            auxDescuento = false;
          }
        });
      });
      this.eliminarReserva(alumnoItem);
      this.habilitarGuardado();

    }, 0);
  }

  // reduce la cantidad de cupos y llama a verificar si se puede habilitar el guardado
  confirmarCursoElegido(alumnoItem): void {
    this.cargando = true;
    if (alumnoItem.codigoAplicado) {
      alumnoItem.status = 'registrado';
      alumnoItem.statusCourseAux = 'test';
    } else {
      alumnoItem.status = 'registrado';
    }
    this.guardarInfoAcademica(alumnoItem);

    let auxDescuento = true;
    
    this.cursosFiltradosAlumnoAMostrar.forEach(element => {
      element.forEach(curso => {
        if ((curso.id == alumnoItem.cursoElegido.id) && auxDescuento) {
          curso.high = curso.high + 1;
          auxDescuento = false;
        }
      });
    });
    this.habilitarGuardado();
  }

  // cuando los cupos son cero no se mostrara este para los demas estudiantes
  excluirCurso(curso, alumnoItem, indexAlumno): boolean {
    const auxCupos = curso.maximun - curso.high;
    if ((auxCupos <= 0)) {
      if (alumnoItem.cursoElegido == null || alumnoItem.cursoElegido.id !== curso.id) {
        if (this.cursosFiltradosAlumnoAMostrar[indexAlumno].length <= 1) {
          this.banderaCursoSinCupos[indexAlumno] = true;
        }
        return false;
      }
    }
    return true;
  }

  // verifica si el ultimo curso disponible fue excluido y nos muestra otras opciones
  excluirEncabezadoArrayVacio(indexAlumno, alumnoItem): boolean {
    if (this.cursosFiltradosAlumnoAMostrar[indexAlumno].length <= 1
      && !this.banderaBotonConfirmar[indexAlumno]) {
      const auxArrayCurso = this.cursosFiltradosAlumnoAMostrar[indexAlumno];
      if (auxArrayCurso[0] != null) {
        const auxCupos = auxArrayCurso[0].maximun - auxArrayCurso[0].high;
        if ((auxCupos <= 0)) {
          if (alumnoItem.cursoElegido == null ||
            alumnoItem.cursoElegido.id != auxArrayCurso[0].id) {
            return false;
          }
        }
      }
    }
    return true;
  }

  // verifica si todos los estudiantes ya confirmaron sus preferencias y habilita el boton siguiente
  habilitarGuardado(): void {
    this.banderaBotonSiguienteGuardar = true;
    let auxValorAnt = true;
    console.log('BanderaBotonConfirmar', this.banderaBotonConfirmar)
    console.log('banderaBotonConfirmarOtrasOpciones', this.banderaBotonConfirmarOtrasOpciones)
    for (let i = 0; i < this.alumnos.length; i++) {
      if (this.banderaBotonConfirmar[i] == null && this.banderaBotonConfirmarOtrasOpciones[i] == null) {
        this.banderaBotonSiguienteGuardar = true;
        auxValorAnt = false;
      } else {
        if (!this.banderaBotonConfirmar[i] && this.banderaBotonConfirmar[i] != null) {
          this.banderaBotonSiguienteGuardar = true;
          auxValorAnt = false;
        } else {
          if (!this.banderaBotonConfirmarOtrasOpciones[i] && this.banderaBotonConfirmarOtrasOpciones[i] != null) {
            this.banderaBotonSiguienteGuardar = true;
            auxValorAnt = false;
          }
        }
      }
      if (auxValorAnt) {
        this.banderaBotonSiguienteGuardar = false;
      }
    }
  }


  guardarInfoAcademica(alumnoItem): void {
    this.cursosService.getCurso(alumnoItem.cursoElegido.id).subscribe(res => {
      const curso: any = res.data();
      if (curso.high < curso.maximun) {
        this.reservarCupoYInscribir(alumnoItem);
      } else {
        for (let i = 0; i < this.cursosFiltradosAlumnoAMostrar.length; i++) {
          for (let j = 0; j < this.cursosFiltradosAlumnoAMostrar[i].length; j++) {
            if (this.cursosFiltradosAlumnoAMostrar[i][j].id === alumnoItem.cursoElegido.id) {
              this.cursosFiltradosAlumnoAMostrar[i].splice(j, 1);
            }
          }
        }
        this.cargando = false;
        // desarrollar el borrado de cupo
        this.messageService.openAlertDialog('lo sentimos se han llenado ' +
          + ' los cupos otra persona a utilzado el ultimo cupo', 'Error');
      }
    });
  }
  reservarCupoYInscribir(alumno): void {
    this.cargando = true;
    this.establecerLaSerie(alumno);
    this.establecerDescripcionCentro(alumno);
    alumno.cursoElegido.registrationDate = new Date();
    try {
      this.inscripcionService.obtenerInscripcionPorAlumno(alumno.id).subscribe(res => {
        let inscripcionId;
        if (alumno.lastInscripcionId != null) {
          inscripcionId = alumno.lastInscripcionId;
        } else {
          inscripcionId = res.docs[0].id;
        }
        alumno.inscripcionId = inscripcionId;
        this.cursosService.establecerPlazaCurso(alumno.cursoElegido.id, alumno.cursoElegido.high + 1)
          .then(() => {
            alumno.showStudent = true;
            alumno.showInscription = false;
            this.inscripcionService.actualizarIncripcion(inscripcionId, alumno).then(() => {
              alumno.cursoElegido.startDateCourse = this.segundosToDateUTC(alumno.cursoElegido.startDate.seconds);
              this.tutorService.updateUserInfoAcademicaAlumno(alumno).then(() => {
                this.cargando = false;
                if (alumno.codigoAplicado != null && alumno.codigoAplicado) {
                  this.actualizarCodigoAUsado(alumno.codigoId, 'Usado', alumno, this.tutor);
                }
                this.inciarContador(alumno, inscripcionId);
              }).catch((error) => {
                alumno.showStudent = false;
                console.log('error error al reservar ' + error);
                this.cargando = false;
              });
            });
          }).catch((error) => {
            console.log('error al disminuir las plazas' + error);
            this.cargando = false;
          });
      });
    } catch (error) {
      this.cargando = false;
      console.log(error);
    }
  }

  private inciarContador(alumno: any, inscripcionId: any): void {
    this.establecerRegistationUser(this.tutor.id, alumno.cursoElegido.registrationDate);
    this.inicializarContador(alumno,
      alumno.cursoElegido.registrationDate.setMinutes(alumno.cursoElegido.registrationDate.getMinutes() + 15));
    this.establecerCourseSelectedTimeUser(this.tutor.id,
      alumno.cursoElegido.registrationDate.setMinutes(alumno.cursoElegido.registrationDate.getMinutes() + 15));
    this.establecerCourseSelectedTimeInscripcion(inscripcionId, alumno.cursoElegido.registrationDate);
  }

  eliminarReserva(alumno): void {
    this.cargando = true;
    alumno.showStudent = false;
    this.inscripcionService.eliminarInscripcion(alumno.inscripcionId).then(() => {
      this.cursosService.establecerPlazaCurso(alumno.cursoElegido.id, alumno.cursoElegido.high).then(() => {
        this.tutorService.eliminarUserInfoAcademicaAlumnoEspecifica(alumno).then(() => {
          alumno.cursoElegido = null;
          alumno.inscripcionId = null;
          alumno.time = null;
          clearInterval(alumno.timeId);
          if (alumno.codigoId != null && alumno.codigoId != '') {
            this.actualizarCodigoNoUsado(alumno.codigoId, 'No usado');
          }
          this.cargando = false;
        }).catch((error) => {
          console.log('error al borrar la info academica ' + error);
          this.cargando = false;
        });
      }).catch((error) => {
        console.log('error al restituir la plaza del curso ' + error);
        this.cargando = false;
      });
    }).catch((error) => {
      alumno.showStudent = true;
      console.log('error al eliminar la inscripcion del alumno ' + error);
      this.cargando = false;
    });
  }

  listaEsperaInscribir(alumno): void {
    this.cargando = true;
    this.inscripcionService.obtenerInscripcionPorAlumno(alumno.id).subscribe(res => {
      const inscripcionId = res.docs[0].id;
      alumno.inscripcionId = inscripcionId;
      alumno.showInscription = true;
      this.inscripcionService.actualizarIncripcionListaEspera(inscripcionId, alumno).then(() => {
        this.tutorService.updateUserStatus(alumno.id, 'espera').then(() => {
          alumno.status = 'espera';
          alumno.listaEspera = true;
          this.cargando = false;
        }).catch((error) => {
          console.log('error lista espera ' + error);
          this.cargando = false;
        });
      });
    });
  }
  eliminarDeListaEspera(alumno): void {
    this.cargando = true;
    // tslint:disable-next-line: deprecation
    this.inscripcionService.obtenerInscripcionPorAlumno(alumno.id).subscribe(res => {
      const inscripcionId = res.docs[0].id;
      alumno.inscripcionId = inscripcionId;
      this.inscripcionService.eliminarInscripcion(inscripcionId).then(() => {
        this.tutorService.updateUserStatus(alumno.id, 'prospectivo').then(() => {
          alumno.listaEspera = false;
          this.cargando = false;
        }).catch((error) => {
          console.log('error al eliminar de la lista de espera ' + error);
          this.cargando = false;
        });
      });
    });
  }

  consultarCuposGrupoAEliminar(alumno): void {
    const idCurso = alumno?.idLastCourse;
    // tslint:disable-next-line: deprecation
    if (idCurso != null && idCurso != undefined) {
      this.cursosService.getCurso(idCurso).subscribe(res => {
        const curso: any = res.data();
        const cuposActuales = curso.high - 1;
        this.eliminarReservaDesdeContrato(alumno, idCurso, cuposActuales);
      });
    }
  }
  eliminarReservaDesdeContrato(alumno, idCurso, cuposActuales): void {
    this.cargando = true;
    alumno.showStudent = false;
    this.inscripcionService.eliminarInscripcion(alumno.inscripcionId).then(() => {
      this.cursosService.establecerPlazaCurso(idCurso, cuposActuales).then(() => {
        this.tutorService.eliminarUserInfoAcademicaAlumno(alumno).then(() => {
          alumno.cursoElegido = null;
          alumno.inscripcionId = null;
          if (alumno.codePromocionalId != null && alumno.codePromocionalId != '') {
            this.actualizarCodigoNoUsado(alumno.codePromocionalId, 'No usado');
          }
          this.cargando = false;
        }).catch((error) => {
          console.log('error al borrar la info academica ' + error);
          this.cargando = false;
        });
      }).catch((error) => {
        console.log('error al restituir la plaza del curso ' + error);
        this.cargando = false;
      });
    }).catch((error) => {
      console.log('error al eliminar la inscripcion del alumno ' + error);
      this.cargando = false;
    });
  }

  siguiente(): void {
    this.cargando = true;
    const date = new Date();
    this.tutorService.updateUserCourseSelectedTime(this.tutor.id, date.setMinutes(date.getMinutes() + 15)).then(() => {
      setTimeout(() => {
        this.tutorService.changeIdTutor(this.idTutor);
        this.cargando = false;
      }, 1000);
    }).catch((error) => {
      console.log('error  ' + error);
    });
    let auxCambiarPagina = false;
    this.alumnos.forEach(alumno => {
      if (alumno.status != null && alumno.status != 'test' && alumno.status != 'registrado' && alumno.status != 'espera' && alumno.cursoElegido != 'ninguno') {
        auxCambiarPagina = true;
      }
      try {
        if (alumno.status == 'espera') {
          this.enviarEmail('Confirmación de tu registro en la lista de espera',
            this.emailEnEspera(alumno?.fullname, alumno?.dia, alumno?.horaCursoSeleccionada, alumno?.centro, alumno?.municipio),
            this.tutor.email);
        }
        if (alumno.statusCourseAux == 'test') {
          this.enviarEmail('Confirmación día de prueba Playbots',
            this.emailDiaPrueba(alumno?.fullname, alumno,
              alumno?.cursoElegido?.descripcionCentro, alumno?.cursoElegido?.descripcionMunicipio, this.initCourseDate, this.endCourseDate), this.tutor.email);
          this.tutorService.updateUserSendEmail(alumno.id);
        }
        if (alumno.cursoElegido == 'ninguno') {
          this.tutorService.updateUserStatus(alumno.id, 'ninguno');
        }
      } catch (e) {
        console.log('error al enviar email', e);
      }
      this.establecerCourseSelectedTimeInscripcion(alumno.inscripcionId, date);
    });
    if (auxCambiarPagina) {
      this.router.navigate(['/contrato']);
    } else {
      this.banderaMensajeWeb = true;
      this.cargando = false;
    }
  }

  establecerLaSerie(alumno): void {
    this.series.forEach(element => {
      if (element.id === alumno.cursoElegido.serie.id) {
        alumno.cursoElegido.serieName = element.name;
      }
    });
  }
  establecerDescripcionCentro(alumno): void {
    this.centers.forEach(element => {
      if (element.id === alumno.cursoElegido.center.id) {
        alumno.cursoElegido.centerDescription = element.description;
      }
    });
  }

  establecerRegistationUser(id, date): void {
    this.tutorService.updateUserRegistrationDate(id, date).then(() => {
    }).catch((error) => {
      console.log('error  ' + error);
    });
  }

  establecerCourseSelectedTimeUser(id, date): void {
    this.tutorService.updateUserCourseSelectedTime(id, date).then(() => {
    }).catch((error) => {
      console.log('error  ' + error);
    });
  }
  establecerCourseSelectedTimeInscripcion(id, date): void {
    this.inscripcionService.updateUserCourseSelectedTime(id, date).then(() => {
    }).catch((error) => {
      console.log('error  ' + error);
    });
  }
  inicializarContador(alumno, date): void {
    alumno.courseSelectedTime = date;
    alumno.timeId = countdown(alumno.courseSelectedTime, (ts) => {
      alumno.time = ts;
      if ((alumno.time.minutes === 0) && (alumno.time.seconds === 0)) {
        console.log('contador llego a cero en infoAcademica');
        this.banderaBotonSiguiente = false;
        this.banderaBotonAtras = true;
        this.limpiarFiltros();
        this.logout();
      }
      this.cambiarSegundoADosDigitos(alumno.time.seconds, alumno);
    });
  }

  enviarEmail(subjectToSend: string, messageToSend: string, emailToSend: string): Promise<any> {
    return this.emailService.sendEmail(subjectToSend, messageToSend, emailToSend)
      .then((responseSus) => {
        console.log('el resultado de la function es ', responseSus);
        if (responseSus) {
          if (responseSus.error) {
          }
        }
        return responseSus;
      }).catch(error => {
      });
  }

  emailEnEspera(nombreAlumno: string, dia: string, hora: any, centro: string, municipio: string): string {
    const messageEmail = `<div style ="text-align: justify;">
    Hola ${this.tutor.fullname}<br/>

    te informamos que ${nombreAlumno} está apuntado en lista de espera en:<br/><br/>


    Centro: ${centro} - ${municipio}<br/><br/>

    Día: ${dia}<br/><br/>

    Hora: ${hora}<br/><br/>

    Nos pondremos en contacto contigo en el caso de que existiera alguna plaza disponible para el curso solicitado.<br/><br/>

    Gracias por tu inscripción,<br/>

    <img class="product-image" style="max-width: 100%;"
    src="https://firebasestorage.googleapis.com/v0/b/playbotscms.appspot.com/o/logo_playbots.png?alt=media&token=2ddbe96b-349c-4819-8b2e-18256f0ef7ff" />
    <br/><br/>

    Avda. de las Civilizaciones 15, local 9<br/>
    41927 Mairena del Aljarafe, Sevilla<br/>
    Tlf.: 854993164 - info@playbots.es<br/><br/>

    Este correo electrónico y, en su caso, cualquier fichero anexo, contiene información confidencial <br/>
    exclusivamente dirigida a su(s) destinatario(s). Toda copia o divulgación deberá ser autorizada por <br/>
    Playbots Education S.L. <br/><br/>

    This e-mail and any attachments are confidential and exclusively directed to its address(es). Any<br/>
    copy or distribution will have to be authorized by Playbots Education S.L.<br/><br/>

    En virtud de la ley 34/2002 LSSI-CE, este mensaje y sus archivos adjuntos pueden contener<br/>
    información confidencial, por lo que se informa de que su uso no autorizado está prohibido por la<br/>
    ley, además se encuentran protegidos por la Constitución Española, que garantiza la<br/>
    confidencialidad, protección y secreto de las comunicaciones. Si ha recibido este mensaje por<br/>
    equivocación, por favor notifíquelo inmediatamente a través de esta misma vía y borre el mensaje<br/>
    original junto con sus ficheros adjuntos sin leerlo o grabarlo total o parcialmente. Los datos<br/>
    personales que consten en esta comunicación son responsabilidad de Playbots Education S.L.<br/>
    con la finalidad de gestionar la relación con nuestros clientes y contactos en relación al ejercicio<br/>
    de nuestra actividad, todo ello bajo la legitimación otorgada por consentimiento expreso del propio<br/>
    interesado, y/o en base a la ejecución de un contrato de servicios. No se cederán datos a terceros<br/>
    salvo obligaciones legales. En cuanto a sus derechos podrá acceder, rectificar y suprimir los datos,<br/>
    limitarlos o incluso oponerse a su tratamiento, entre otros derechos, contactando con nosotros por<br/>
    email o por correo postal dirigido a Avda. de las Civilizaciones 15, local 9 - 41927 Mairena del<br/>
    Aljarafe, Sevilla.<br/><br/>

    </div>`;

    return messageEmail;
  }

  emailDiaPrueba(nombreAlumno: string, alumno: any, centro: string, municipio: string, initCourseDate: Date, endCourseDate: Date): string {
    // anexo 1
    // Curso: ${course.description}<br/><br/>

    // Día: ${course.weekDays[0]}<br/><br/>

    // Hora: ${course.startTime.hour}: ${course.startTime.minute}– ${course.endTime.hour}: ${course.endTime.minute}<br/><br/>

    
    const fechaInscripcionString =  moment().format('DD/MM/YYYY');
    const messageEmail = `<div style ="text-align: justify;">
    Hola ${this.tutor.fullname}<br/>
    te informamos que está confirmada la clase de prueba de ${nombreAlumno} en:<br/><br/>

    Centro: ${centro} - ${municipio}<br/><br/>

    Curso: ${alumno.cursoElegido.description}<br/><br/>

    Fecha de inscripción: ${fechaInscripcionString}<br/><br/>

    Día de prueba ${this.verificarDiaPrueba(alumno.dia, initCourseDate, endCourseDate)}<br/><br/>

    Hora: ${alumno.horaSeleccionada}<br/><br/>

    Gracias por tu inscripción,<br/>

    <img class="product-image" style="max-width: 100%;"
    src="https://firebasestorage.googleapis.com/v0/b/playbotscms.appspot.com/o/logo_playbots.png?alt=media&token=2ddbe96b-349c-4819-8b2e-18256f0ef7ff" />
    <br/><br/>

    Avda. de las Civilizaciones 15, local 9<br/>
    41927 Mairena del Aljarafe, Sevilla<br/>
    Tlf.: 854993164 - info@playbots.es<br/><br/>

    Este correo electrónico y, en su caso, cualquier fichero anexo, contiene información confidencial <br/>
    exclusivamente dirigida a su(s) destinatario(s). Toda copia o divulgación deberá ser autorizada por <br/>
    Playbots Education S.L. <br/><br/>

    This e-mail and any attachments are confidential and exclusively directed to its address(es). Any<br/>
    copy or distribution will have to be authorized by Playbots Education S.L.<br/><br/>

    En virtud de la ley 34/2002 LSSI-CE, este mensaje y sus archivos adjuntos pueden contener<br/>
    información confidencial, por lo que se informa de que su uso no autorizado está prohibido por la<br/>
    ley, además se encuentran protegidos por la Constitución Española, que garantiza la<br/>
    confidencialidad, protección y secreto de las comunicaciones. Si ha recibido este mensaje por<br/>
    equivocación, por favor notifíquelo inmediatamente a través de esta misma vía y borre el mensaje<br/>
    original junto con sus ficheros adjuntos sin leerlo o grabarlo total o parcialmente. Los datos<br/>
    personales que consten en esta comunicación son responsabilidad de Playbots Education S.L.<br/>
    con la finalidad de gestionar la relación con nuestros clientes y contactos en relación al ejercicio<br/>
    de nuestra actividad, todo ello bajo la legitimación otorgada por consentimiento expreso del propio<br/>
    interesado, y/o en base a la ejecución de un contrato de servicios. No se cederán datos a terceros<br/>
    salvo obligaciones legales. En cuanto a sus derechos podrá acceder, rectificar y suprimir los datos,<br/>
    limitarlos o incluso oponerse a su tratamiento, entre otros derechos, contactando con nosotros por<br/>
    email o por correo postal dirigido a Avda. de las Civilizaciones 15, local 9 - 41927 Mairena del<br/>
    Aljarafe, Sevilla.<br/><br/>

    </div>`;

    return messageEmail;
  }

  verificarDiaPrueba(day: string, initCourseDate: Date, endCourseDate: Date): string {
    const initDateUnix = initCourseDate.getTime()
    const endDateUnix = endCourseDate.getTime()
    const inscripcionDate = new Date();
    const weekDay = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const weekDayShow = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const monthShow = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre',
  'Octubre', 'Noviembre', 'Diciembre'];
  let nextDate;
  // Se comprueba que si es el mismo dia y si empieza dentro del periodo del curso
    if (day.toLowerCase() === weekDay[moment(inscripcionDate).weekday()]  && moment(initDateUnix).isBefore(moment(inscripcionDate))){
      return `Hoy ${weekDayShow[moment(inscripcionDate).weekday()].toLowerCase()}`;
    } else {

      if (initDateUnix <= inscripcionDate.getTime() && endDateUnix >= inscripcionDate.getTime()) {
        for (let i = 0; i < 7; i++) {
          // Itera 7 dias contando desde el del inicio del cursos para encontrar el dia de la semana
          // mas proximo seleccionado por el usuario en el registro.
          if (weekDay[moment(inscripcionDate).day(moment(inscripcionDate).day() + i).day()] === day.toLowerCase()) {
            nextDate = moment(inscripcionDate).day(moment(inscripcionDate).day() + i)
            return `el próximo ${weekDayShow[nextDate.day()]} ${nextDate.date()} de ${monthShow[nextDate.month()]} de ${nextDate.year()}`;
          }
        }
      } else {
        if (initDateUnix > inscripcionDate.getTime()) {
          for (let i = 0; i < 7; i++) {
            if (weekDay[moment(initDateUnix).day(moment(initDateUnix).day() + i).day()] === day.toLowerCase()) {
              nextDate = moment(initDateUnix).day(moment(initDateUnix).day() + i)
              return `el próximo ${weekDayShow[nextDate.day()]} ${nextDate.date()} de ${monthShow[nextDate.month()]} de ${nextDate.year()}`;
            }
          }
        } else {
          return `del curso se encuentra finalizado para el siguente ${weekDayShow[weekDay.indexOf(day.toLocaleLowerCase())].toLocaleLowerCase()}, contacte con nosotros para más información.`;
        } 
      }
    }
  }

  verificarCodigosIguales(): void {
    let codeAnterior: string;
    this.codigosIguales = false;
    this.alumnos.forEach(alumno => {
      if ((alumno.code != null) && (alumno.code != '')) {
        codeAnterior = alumno.code;
        this.alumnos.forEach(alumnoAux => {
          if ((alumno.id != alumnoAux.id) && (alumnoAux.code != null) && (alumnoAux.code != '')) {
            if (codeAnterior != null && (codeAnterior == alumnoAux.code) && !this.codigosIguales) {
              this.codigosIguales = true;
              this.messageService.openAlertDialog('Los codigos deben ser diferentes', 'Error');
            }
          }
        });
      }
    });
  }

  async verificarCodesPromo(): Promise<void> {
    await this.getCurseInformation()
    this.cargando = true;
    let sinError = true;
    for (const alumno of this.alumnos) {
      try {
        if ((alumno.code != null) && (alumno.code != '')) {
          if (alumno.didTest == null) {
            await this.codeService.getCodeByCode(alumno.code).then(async res => {
              if (!res.empty) {
                const code = res.docs[0].data();
                code.id = res.docs[0].id;
                const fechaActual = new Date();
                fechaActual.setHours(fechaActual.getHours() + 6);
                code.startDate = this.segundosToDate(code.startDate.seconds);
                code.endDate = this.segundosToDate(code.endDate.seconds);
                //code.startDate = this.segundosToDate(code.date.seconds);
                //code.endDate = this.segundosToDate(code.endDate.seconds);
                if (code.state == 'No usado' && code.type == 'Prueba'
                  && code.endDate > fechaActual && code.startDate < fechaActual) {
                  alumno.codigoId = code.id;
                  alumno.codigoAplicado = true;
                  alumno.codigoTieneError = false;
                } else {
                  sinError = false;
                  alumno.mensajeErrorCodigo = 'Código no valido';
                  alumno.codigoAplicado = false;
                  alumno.codigoTieneError = true;
                }
              } else {
                if (!this.isCampus) {
                  sinError = false;
                  alumno.mensajeErrorCodigo = 'Código no valido';
                  alumno.codigoAplicado = false;
                  alumno.codigoTieneError = true;
                }

              }
            });
          } else {
            sinError = false;
            alumno.mensajeErrorCodigo = 'No aplica promoción. Usuario registrado';
            alumno.codigoAplicado = false;
            alumno.codigoTieneError = true;
          }
        } else {
          sinError = false;
          alumno.mensajeErrorCodigo = 'El código es obligatorio';
          alumno.codigoAplicado = false;
          alumno.codigoTieneError = true;
        }
      } catch (e) {
        sinError = false;
        alumno.mensajeErrorCodigo = 'Código no valido';
        alumno.codigoAplicado = false;
        alumno.codigoTieneError = true;
      }
    }
    if (sinError) {
      this.banderaBotonSiguiente = true;
      this.banderaBotonAtras = false;
    }
    this.cargando = false;

  }

  segundosToDate(secs): Date {
    const t = new Date(1970, 0, 1);
    t.setSeconds(secs);
    return t;
  }
  segundosToDateUTC(secs): Date {
    const t = new Date(Date.UTC(1970, 0, 1));
    t.setUTCSeconds(secs);
    return t;
  }

  limpiarErrorCampoCodigo(alumno): void {
    alumno.codigoTieneError = false;
    alumno.codigoAplicado = false;
  }

  actualizarCodigoNoUsado(idCode, status): void {
    this.codeService.updateCodeStatusToNoUsed(idCode, status).then(() => {
    }).catch((error) => {
      console.log('error al actualizar el estado del codigo promocional  ' + error);
    });
  }

  actualizarCodigoAUsado(idCode, status, alumno, tutor): void {
    this.codeService.updateCodeStatusToUsed(idCode, status, alumno, tutor).then(() => {
    }).catch((error) => {
      console.log('error al actualizar el estado del codigo promocional  ' + error);
    });
  }


  actualizarIdTutor(): void {
    setTimeout(() => {
      this.tutorService.changeIdTutor(this.idTutor);
    }, 500);
  }

  cambiarSegundoADosDigitos(segundo, alumno): void {
    try {
      switch (segundo) {
        case 0:
          alumno.time.seconds = '00';
          break;
        case 1:
          alumno.time.seconds = '01';
          break;
        case 2:
          alumno.time.seconds = '02';
          break;
        case 3:
          alumno.time.seconds = '03';
          break;
        case 4:
          alumno.time.seconds = '04';
          break;
        case 5:
          alumno.time.seconds = '05';
          break;
        case 6:
          alumno.time.seconds = '06';
          break;
        case 7:
          alumno.time.seconds = '07';
          break;
        case 8:
          alumno.time.seconds = '08';
          break;
        case 9:
          alumno.time.seconds = '09';
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  }

}
